import { useKeycloak } from "@react-keycloak/web";
import { useState } from "react";
import { Card, CardBody, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import hasRoles from "../../../../security/hasRoles";
import TraingPathList from "./traingPathList";
import styles from "./traingPathListDisplayType.module.scss";
import { translate } from "react-switch-lang";

export enum RequestType {
  USERS_TRAINING,
  USER_OTHER_TRAINING,
  ADMIN_VISITOR,
  ARCHIVE,
}

const TraingPathListDisplayType: React.FC<{ t: (key: string) => string }> = props => {
  const { keycloak } = useKeycloak();
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const [activeTab, setActiveTab] = useState("1");

  return (
    <>
      {hasRoleAdmin || !keycloak.authenticated ? (
        <TraingPathList requestType={RequestType.ADMIN_VISITOR} />
      ) : (
        <Row>
          <Col lg="12 box-col-12" xl="12 xl-100" className={styles["content_col"]}>
            <Card className={styles["user-training-tabs-wrapper"]}>
              <CardBody>
                <h3>{props.t("training_path_list_user")}</h3>
                <Nav className={"border-tab"} tabs>
                  <NavItem>
                    <NavLink title="Afficher votre parcours" className={activeTab === "1" ? `active ${styles["training-tabs"]}` : styles["training-tabs"]} onClick={() => setActiveTab("1")}>
                      {props.t("access_to_the_training_path")}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      title="Afficher les autres parcours disponibles"
                      className={activeTab === "2" ? `active ${styles["training-tabs"]}` : styles["training-tabs"]}
                      onClick={() => setActiveTab("2")}
                    >
                      {props.t("other_training_path_available")}
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane className="fade show" tabId="1">
                    <TraingPathList requestType={RequestType.USERS_TRAINING} tabId={activeTab} />
                  </TabPane>
                  <TabPane className="fade show" tabId="2">
                    <TraingPathList requestType={RequestType.USER_OTHER_TRAINING} tabId={activeTab} />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};
export default translate(TraingPathListDisplayType);
